module.exports = __webpack_public_path__ + "static/media/DataDeletion.c3bf48ee.md";